import type { Node } from '../../models/scene';
import { BaseNodeCommand, type NodeChangeRecord } from '../base/BaseNodeCommand';

export class UpdateNodePatchCommand extends BaseNodeCommand {
  constructor(
    private readonly nodeId: string,
    private readonly patch: Record<string, unknown>,
    options: { label?: string; skipHistory?: boolean } = {},
  ) {
    super(options.label ?? 'Update Node Patch', 'Apply a partial node update');
    if (options.skipHistory) Object.assign(this, { skipHistory: true });
  }

  protected doExecute(): NodeChangeRecord[] {
    const record = this.getMutationManager().applyNodeChange(this.nodeId, this.patch as Partial<Node>);
    return record ? [record] : [];
  }
}
